import SEOLandingTemplate from './SEOLandingTemplate';

export default function SEOAnalyzerPage() {
  return (
    <SEOLandingTemplate
      title="SEO Analyzer"
      metaTitle="Free SEO Analyzer | Sungresh"
      metaDescription="Combine domain authority, backlink, site audit, and on-page data into one view to see where a site's SEO stands."
      h1="Free SEO Analyzer"
      sub="Pulls together domain authority and backlink data, a technical site audit, and on-page checks so you get one combined view instead of running three separate tools."
      keywords="seo analyzer, free seo analyzer, website seo analyzer, seo audit tool"
      ctaLink="/domain/overview"
      ctaText="Analyze a Site Free"
      features={[
        { icon: '🌐', title: 'Domain Authority', desc: 'Authority score, backlinks, and referring domains' },
        { icon: '🔑', title: 'Organic Keywords', desc: 'Keywords the domain currently ranks for' },
        { icon: '⚡', title: 'Technical Audit', desc: 'A live crawl checking common technical SEO issues' },
        { icon: '📝', title: 'On-Page Review', desc: 'Title, meta, heading, and content checks against a target keyword' },
      ]}
      faqs={[
        { q: 'What exactly does this analyze?', a: 'It combines three separate checks — domain/backlink data, a technical site crawl, and on-page keyword optimization — into a single overview so you don\'t have to run each tool separately for a first-pass audit.' },
        { q: 'What should I fix first if I find issues?', a: 'Start with anything that blocks crawling or indexing entirely (missing titles, broken pages, no HTTPS), then move to on-page gaps (missing meta descriptions, weak heading structure), then longer-term work like building backlinks and adding content depth.' },
        { q: 'How current is the data?', a: 'Domain and backlink figures come from a third-party data provider and update on that provider\'s own schedule. The technical and on-page checks are performed live against your page at the moment you run the tool.' },
      ]}
    />
  );
}
